import { Controller } from "@hotwired/stimulus"

// THE DUE LIST'S BULK "SCHEDULE VISIT" BUTTON (TASK-238.7, doc-39 §6.1,
// board "Entry points A"). Sits beside `form-picker` on the SAME checkboxes
// (every one carries BOTH controllers' `change` actions — see
// schedules/index.html.erb) and layers one extra rule on top of its
// enable/disable: every ticked row must be at the SAME site, because one
// visit can only carry one site. `form-picker` already disables the button
// at zero selection; this only ever tightens that, never loosens it.
//
// The date is NEVER computed here — "next working day" is server
// arithmetic (WorkingDays.following, same house rule
// visit_schedule_form_controller.js's own comment states: "the server
// count/date is the truth"). `nextWorkingDayValue` is handed over once,
// read-only.
export default class extends Controller {
  static targets = ["checkbox", "button"]
  static values = { newVisitPath: String, nextWorkingDay: String, returnTo: String }

  // Bound to `change` on every checkbox, AFTER form-picker#update in the
  // same data-action list — so this always has the LAST word on whether
  // the button is enabled.
  recompute() {
    if (!this.hasButtonTarget) return

    const checked = this.checkboxTargets.filter((checkbox) => checkbox.checked && !checkbox.disabled)
    const button = this.buttonTarget

    if (checked.length === 0) {
      // No ASSET row ticked (nothing, or only site rows ticked for a works
      // project): form-picker may have enabled the button for those, but a
      // visit needs an asset.
      button.removeAttribute("title")
      button.disabled = true
      return
    }

    const siteIds = new Set(checked.map((checkbox) => checkbox.dataset.siteId || ""))
    if (siteIds.size > 1) {
      button.disabled = true
      button.title = "All selected assets must be at the same site"
      return
    }

    button.disabled = false
    button.removeAttribute("title")
    button.textContent = checked.length === 1 ?
      "Schedule 1 Visit for 1 Asset" : `Schedule 1 Visit for ${checked.length} Assets`

    const params = new URLSearchParams()
    const siteId = checked[0].dataset.siteId
    if (siteId) params.set("site_id", siteId)
    checked.forEach((checkbox) => {
      params.append("product_instance_ids[]", checkbox.value)
      // The rule that produced each ticked row (decision-67) — the server
      // resolves these into forms once the project is known, same shape
      // as the kebab's single rule_id (ProductTypes::InspectionFormsFor's
      // own first-seen-order union, but of rule forms instead of product
      // forms). Several rows can share a rule (two assets on the same
      // product rule); duplicates are harmless, the server dedupes.
      if (checkbox.dataset.ruleId) params.append("rule_ids[]", checkbox.dataset.ruleId)
    })
    if (this.hasNextWorkingDayValue) params.set("scheduled_on", this.nextWorkingDayValue)
    if (this.hasReturnToValue && this.returnToValue) params.set("return_to", this.returnToValue)

    button.setAttribute("data-slideover-turbo-frame-src-value", `${this.newVisitPathValue}?${params.toString()}`)
  }
}
